export default __webpack_public_path__ + "static/media/resturant.7fb05856.png";